import React from 'react';
import SoloSimulatorPage from './SoloSimulatorPage';
import PePlanPage from './PePlanPage';

type PeCoachToolPlaceholderPageProps = {
  toolId?: 'pe-plan' | 'planungsrechner' | 'pe-solo';
  mode?: 'god' | 'premium';
};

const COPY: Record<
  'pe-plan' | 'pe-solo',
  { title: string; eyebrow: string; body: string; note: string }
> = {
  'pe-plan': {
    title: 'Planungsrechner',
    eyebrow: 'Coach-Planung · in Aufbau',
    body:
      'Virtuelle Salon-Simulation für Pläne und Szenarien: Kosten, Personal und Strukturen vorausschauend durchspielen. Primär ein Coach-Werkzeug — für Mandanten nur zuschaltbar, wenn ihr es bewusst freigibt.',
    note: 'Dieses Modul wird noch aufgebaut. Der Menüpunkt ist bereits verankert.',
  },
  'pe-solo': {
    title: 'Solo-Simulator',
    eyebrow: 'God-Mode · nur Coach/Admin',
    body:
      'Wirtschaftlichkeits-Simulator für Einzelkämpfer-Szenarien. Wird ausschließlich von Coaches im God-Modus bedient — nicht als Mandanten-Selbstbedienung gedacht.',
    note: 'Dieses Modul wird noch aufgebaut. Sichtbar nur im God-Modus.',
  },
};

/**
 * Platzhalter für Planungsrechner / Solo-Simulator — Menü bereits aktiv.
 * pe-solo → echte Sandbox-Seite (kein neuer Menüpunkt).
 * pe-plan → echte Sandbox-Seite PePlanPage.
 */
const PeCoachToolPlaceholderPage: React.FC<PeCoachToolPlaceholderPageProps> = ({
  toolId = 'pe-plan',
  mode,
}) => {
  if (toolId === 'pe-solo') {
    return <SoloSimulatorPage />;
  }

  if (toolId === 'planungsrechner') {
    return <PePlanPage mode={mode ?? 'god'} />;
  }

  if (toolId === 'pe-plan') {
    return <PePlanPage mode={mode ?? 'premium'} />;
  }

  const copy = COPY['pe-plan'];

  return (
    <div className="w-full max-w-3xl mx-auto px-4 py-10">
      <div className="rounded-2xl border border-[#E6C299]/35 bg-[#0f1015]/90 p-8 md:p-10 shadow-[0_0_40px_rgba(230,194,153,0.08)]">
        <p className="text-[10px] font-black uppercase tracking-[0.25em] text-[#E6C299]/80 mb-3">
          {copy.eyebrow}
        </p>
        <h1 className="text-2xl md:text-3xl font-black text-white tracking-tight mb-4">
          {copy.title}
        </h1>
        <p className="text-slate-300 text-sm md:text-base leading-relaxed mb-6">{copy.body}</p>
        <p className="text-[11px] text-slate-500 uppercase tracking-widest font-bold">{copy.note}</p>
      </div>
    </div>
  );
};

export default PeCoachToolPlaceholderPage;
